import gql from 'graphql-tag';

export default gql`
    mutation RevertStages($input: RevertStagesInput) {
        revertStages(input: $input) {
            errors
        }
    }
`;
